/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";
import constants from "@/constants.js";

export default {
  setInternetConnectionStatus({ commit }, value) {
    console.log("setInternetConnectionStatus", value);
    commit("SET_INTERNET_CONNECTION_STATUS", value);
  },
  async fetchUser({ commit }, _id) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/users/${_id}`);
      commit("SET_USER_DATA", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async fetchUserBySlug({ commit }, userSlug) {
    try {
      const slug = userSlug;
      const resObj = await axios.get(`${constants.apiHost}/users`, {
        params: { slug },
      });
      // console.log(resObj);
      commit("SET_USER_DATA", resObj.data.data[0]);
      return resObj.data.data[0];
    } catch (error) {
      throw error;
    }
  },
  async fetchUserByEmail({ commit }, { email }) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/users`, {
        params: { email },
      });
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async updateProfilePicture({ commit }, { ppObj, _id }) {
    try {
      const resObj = await axios.patch(
        `${constants.apiHost}/users/${_id}`,
        ppObj
      );
      commit("SET_PROFILE_PICTURE", resObj.data.profilePictureUrl);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveDob({ commit }, dobObj) {
    try {
      const _id = dobObj._id;
      const dob = dobObj.dob;
      const collectionName = dobObj.collectionName;
      //// console.log(dobObj);
      const resObj = await axios.patch(
        `${constants.apiHost}/${collectionName}/${_id}`,
        { dob }
      );
      commit("SET_DOB", resObj.data.dob);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveGender({ commit }, genderObj) {
    try {
      const _id = genderObj._id;
      const gender = genderObj.gender;
      const collectionName = genderObj.collectionName;
      //// console.log(genderObj);
      const resObj = await axios.patch(
        `${constants.apiHost}/${collectionName}/${_id}`,
        { gender }
      );
      commit("SET_GENDER", resObj.data.gender);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveFirstName({ commit }, firstNameObj) {
    try {
      const _id = firstNameObj._id;
      const firstName = firstNameObj.firstName;
      const collectionName = firstNameObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/${collectionName}/${_id}`,
        { firstName }
      );
      commit("SET_FIRST_NAME", resObj.data.firstName);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveLastName({ commit }, lastNameObj) {
    try {
      const _id = lastNameObj._id;
      const lastName = lastNameObj.lastName;
      const collectionName = lastNameObj.collectionName;
      //// console.log(lastNameObj);
      const resObj = await axios.patch(
        `${constants.apiHost}/${collectionName}/${_id}`,
        { lastName }
      );
      commit("SET_LAST_NAME", resObj.data.lastName);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveCareerObjective({ commit }, careerObjectiveObj) {
    try {
      const _id = careerObjectiveObj._id;
      const careerObjective = careerObjectiveObj.careerObjective;
      const collectionName = careerObjectiveObj.collectionName;
      //// console.log(careerObjectiveObj);
      const resObj = await axios.patch(
        `${constants.apiHost}/${collectionName}/${_id}`,
        { careerObjective }
      );
      commit("SET_CAREER_OBJECTIVE", resObj.data.careerObjective);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveAbout({ commit }, aboutObj) {
    try {
      const _id = aboutObj._id;
      const about = aboutObj.about;
      const collectionName = aboutObj.collectionName;
      //// console.log(aboutObj);
      const resObj = await axios.patch(
        `${constants.apiHost}/${collectionName}/${_id}`,
        { about }
      );
      commit("SET_ABOUT", resObj.data.about);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async savePersonalWebsite({ commit }, personalWebsiteObj) {
    try {
      const _id = personalWebsiteObj._id;
      const personalWebsite = personalWebsiteObj.personalWebsite;
      const collectionName = personalWebsiteObj.collectionName;
      //// console.log(personalWebsiteObj);
      const resObj = await axios.patch(
        `${constants.apiHost}/${collectionName}/${_id}`,
        { personalWebsite }
      );
      commit("SET_PERSONAL_WEBSITE", resObj.data.personalWebsite);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveSkypeProfile({ commit }, skypeProfileObj) {
    try {
      const _id = skypeProfileObj._id;
      const skypeProfile = skypeProfileObj.skypeProfile;
      const collectionName = skypeProfileObj.collectionName;
      //// console.log(skypeProfileObj);
      const resObj = await axios.patch(
        `${constants.apiHost}/${collectionName}/${_id}`,
        { skypeProfile }
      );
      commit("SET_SKYPE_PROFILE", resObj.data.skypeProfile);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveFacebookProfile({ commit }, facebookProfileObj) {
    try {
      const _id = facebookProfileObj._id;
      const facebookProfile = facebookProfileObj.facebookProfile;
      const collectionName = facebookProfileObj.collectionName;
      //// console.log(facebookProfileObj);
      const resObj = await axios.patch(
        `${constants.apiHost}/${collectionName}/${_id}`,
        { facebookProfile }
      );
      commit("SET_FACEBOOK_PROFILE", resObj.data.facebookProfile);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveContactNumber({ commit }, contactNumberObj) {
    try {
      const _id = contactNumberObj._id;
      const contactNumber = contactNumberObj.contactNumber;
      const collectionName = contactNumberObj.collectionName;
      //// console.log(contactNumberObj);
      const resObj = await axios.patch(
        `${constants.apiHost}/${collectionName}/${_id}`,
        { contactNumber }
      );
      commit("SET_CONTACT_NUMBER", resObj.data.contactNumber);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveTwitterProfile({ commit }, twitterProfileObj) {
    try {
      const _id = twitterProfileObj._id;
      const twitterProfile = twitterProfileObj.twitterProfile;
      const collectionName = twitterProfileObj.collectionName;
      //// console.log(twitterProfileObj);
      const resObj = await axios.patch(
        `${constants.apiHost}/${collectionName}/${_id}`,
        { twitterProfile }
      );
      commit("SET_TWITTER_PROFILE", resObj.data.twitterProfile);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveAddress({ commit }, addressObj) {
    try {
      const _id = addressObj._id;
      const address = addressObj.address;
      const collectionName = addressObj.collectionName;
      //// console.log(addressObj);
      const resObj = await axios.patch(
        `${constants.apiHost}/${collectionName}/${_id}`,
        { address }
      );
      commit("SET_ADDRESS", resObj.data.address);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveLinkedinProfile({ commit }, linkedinProfileObj) {
    try {
      const _id = linkedinProfileObj._id;
      const linkedinProfile = linkedinProfileObj.linkedinProfile;
      const collectionName = linkedinProfileObj.collectionName;
      //// console.log(linkedinProfileObj);
      const resObj = await axios.patch(
        `${constants.apiHost}/${collectionName}/${_id}`,
        { linkedinProfile }
      );
      //// console.log(resObj.data);
      commit("SET_LINKEDIN_PROFILE", resObj.data.linkedinProfile);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveDiscordProfile({ commit }, discordProfileObj) {
    try {
      const _id = discordProfileObj._id;
      const discordProfile = discordProfileObj.discordProfile;
      const collectionName = discordProfileObj.collectionName;
      //// console.log(discordProfileObj);
      const resObj = await axios.patch(
        `${constants.apiHost}/${collectionName}/${_id}`,
        { discordProfile }
      );
      //// console.log(resObj.data);
      commit("SET_DISCORD_PROFILE", resObj.data.discordProfile);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  ////////////////////////////////////////
  /// Skills
  ///////////////////////////////////////

  async saveProfession({ commit }, professionObj) {
    try {
      const _id = professionObj._id;
      const profession = professionObj.profession;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(`${constants.apiHost}/users/${_id}`, {
        profession,
      });
      // console.log(resObj);
      commit("SET_PROFESSION", resObj.data.profession);
      return resObj;
    } catch (error) {
      throw error;
    }
  },

  /////////////////////
  /// Resume Config
  /////////////////////

  async saveTemplateColorCode({ commit }, resumeConfigObj) {
    try {
      const _id = resumeConfigObj._id;
      const templateColorCode = resumeConfigObj.templateColorCode;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(`${constants.apiHost}/users/${_id}`, {
        templateColorCode,
      });
      commit("SET_TEMPLATE_COLOR_CODE", resObj.data.templateColorCode);
      return resObj;
    } catch (error) {
      throw error;
    }
  },

  ////////////////////////////////////////
  /// Resume Status
  ////////////////////////////////////////

  async updateResumeStatus({ commit }, publishObj) {
    try {
      const userId = publishObj.userId;
      const resumeStatus = publishObj.resumeStatus;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(`${constants.apiHost}/users/${userId}`, {
        resumeStatus,
      });
      commit("SET_RESUME_STATUS", resObj.data.resumeStatus);
      return resObj;
    } catch (error) {
      throw error;
    }
  },

  ////////////////////////////////////////
  /// Gala Avatar
  ////////////////////////////////////////
  async updateGalaAvtar({ commit }, data) {
    try {
      const userId = data.userId;
      const galaAvatar = data.galaAvatar;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(`${constants.apiHost}/users/${userId}`, {
        galaAvatar,
      });
      console.log("resObj.data.galaAvatar", resObj.data.galaAvatar);
      commit("SET_GALA_AVATAR", resObj.data.galaAvatar);
      return resObj;
    } catch (error) {
      throw error;
    }
  },

  ////////////////////////////////////////
  /// REVEAL STATUS
  ////////////////////////////////////////

  async revealTermsUpdate({ commit }, payload) {
    try {
      const userId = payload.userId;
      console.log("pledge payload", payload);
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(`${constants.apiHost}/users/${userId}`, {
        revealTermsStatus: payload.revealTermsStatus,
        flag: "pledgeEmailSent",
        mentorAssigned: payload.mentorAssigned,
        firstName: payload.firstName,
        lastName: payload.lastName,
        email: payload.email,
      });
      console.log("resObj.data.revealTermsStatus", resObj.data);
      commit("SET_REVEAL_TERMS", resObj.data.revealTermsStatus);
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },

  ////////////////////////////////////////
  /// Resume Template
  ////////////////////////////////////////

  async updateResumeTemplate({ commit }, resumeTemplateObj) {
    try {
      const userId = resumeTemplateObj.userId;
      const resumeTemplate = resumeTemplateObj.resumeTemplate;
      // const collectionName = companyObj.collectionName;
      // console.log(resumeTemplate);
      const resObj = await axios.patch(`${constants.apiHost}/users/${userId}`, {
        resumeTemplate,
      });
      commit("SET_RESUME_TEMPLATE", resObj.data.resumeTemplate);
      return resObj;
    } catch (error) {
      throw error;
    }
  },

  /////////////////////////////////
  /// Show Career History On Map
  /////////////////////////////////

  async saveShowCareerHistoryOnMap({ commit }, showCareerHistoryOnMapObj) {
    try {
      const _id = showCareerHistoryOnMapObj._id;
      const showCareerHistoryOnMap =
        showCareerHistoryOnMapObj.showCareerHistoryOnMap;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(`${constants.apiHost}/users/${_id}`, {
        showCareerHistoryOnMap,
      });
      commit(
        "SET_SHOW_CAREER_HISTORY_ON_MAP",
        resObj.data.showCareerHistoryOnMap
      );
      return resObj;
    } catch (error) {
      throw error;
    }
  },

  /////////////////////////////////
  /// User Dashboard
  /////////////////////////////////

  async saveProfile({ commit }, userProfileObj) {
    try {
      const _id = userProfileObj._id;
      const payload = {
        firstName: userProfileObj.firstName,
        lastName: userProfileObj.lastName,
        dob: userProfileObj.dob,
        gender: userProfileObj.gender,
        about: userProfileObj.about,
      };
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/users/${_id}`,
        payload
      );
      // // console.log(resObj);
      commit("SET_FIRST_NAME", resObj.data.firstName);
      commit("SET_LAST_NAME", resObj.data.lastName);
      commit("SET_DOB", resObj.data.dob);
      commit("SET_GENDER", resObj.data.gender);
      commit("SET_ABOUT", resObj.data.about);
      return resObj;
    } catch (error) {
      throw error;
    }
  },

  async findUsersSubscribedApps({ commit }, userId) {
    try {
      const resObj = await axios.get(
        `${constants.apiHost}/users-subscribed-apps`,
        { params: { userId } }
      );
      commit("SET_USERS_SUBSCRIBED_APPS", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },

  /////////////////////////////////
  /// Create User if doen't exists
  /////////////////////////////////

  async createUserWhenParsed({ commit }, userDetails) {
    try {
      const resObj = await axios.post(
        `${constants.apiHost}/users`,
        userDetails
      );
      console.log(resObj);
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchUserOrganizations({ commit }, { userId }) {
    try {
      if (userId) {
        const organizations = await axios.get(
          `${constants.platformServiceUrl}/employees/user/${userId}`
        );
        commit("SAVE_USER_ORGANIZATIONS", organizations.data);
        commit("SET_USER_ORGANIZATION", organizations.data[0]);
        return organizations.data;
      }
      return [];
    } catch (err) {
      throw err;
    }
  },
  async fetchUserAppSubscriptions({ commit }, payload) {
    try {
      const resObj = await axios.get(
        `${constants.gatewayServiceUrl}/user/app-subscriptions/${payload.userId}`
      );
      commit("SET_USER_APP_SUBSCRIPTIONS", resObj.data.data);
      return resObj.data.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchOrganizationById({ commit }, _id) {
    try {
      const resObj = await axios.get(
        `${constants.apiHost}/organization/${_id}`
      );
      // commit("SET_ORGANIZATION", resObj.data);
      // // console.log(resObj);
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchGalaAvatar({ commit }, { userId }) {
    try {
      const resObj = await axios.get(
        `${constants.gatewayServiceUrl}/journey/gala/avatar/${userId}`
      );
      commit("SET_GALA_AVATAR", resObj.data);
    } catch (error) {
      throw error;
    }
  },
  async fetchGalaAbilities({ commit }, { userId }) {
    try {
      const resObj = await axios.get(
        `${constants.gatewayServiceUrl}/journey/gala/ability/${userId}`
      );
      commit("SET_GALA_ABILITIES", resObj.data);
      commit("SET_GALA_PRIORITIES", resObj.data);
    } catch (error) {
      throw error;
    }
  },
  async getAssignedUser({ commit }, _id) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/users/${_id}`);
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async getGrowthPlans(_, payload) {
    try {
      const resObj = await axios.get(
        `${constants.apiHost}/coach/growth-plan/${payload.orgId}/${payload.userId}`
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async getUserTokens(_, payload) {
    try {
      const resObj = await axios.get(
        `${constants.gatewayServiceUrl}/user-wallet/aggregated/${payload.userId}`
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async getUserOrgTokens(_, payload) {
    try {
      const resObj = await axios.get(
        `${constants.gatewayServiceUrl}/user-wallet/aggregated/organization-grouped/${payload.userId}`
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchJourneyQuests(_, payload) {
    try {
      const resObj = await axios.post(
        `${constants.gatewayServiceUrl}/journey/gala/anics`,
        payload
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async getCustomCourses(_, payload) {
    try {
      const resObj = await axios.get(
        `${constants.gatewayServiceUrl}/alex/library/library-item-group/${payload.orgId}`,
        payload
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async activateTimer(_, payload) {
    try {
      const resObj = await axios.post(
        `${constants.gatewayServiceUrl}/work-time-learning/timer/activate`,
        payload
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async getTimer(_, payload) {
    try {
      const resObj = await axios.get(
        `${constants.gatewayServiceUrl}/work-time-learning/timer/${payload.orgId}/${payload.userId}`,
        payload
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },

  async claimTimer(_, payload) {
    try {
      const resObj = await axios.post(
        `${constants.gatewayServiceUrl}/work-time-learning/timer/claim`,
        payload
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },

  async postAttendance(_, payload) {
    try {
      const resObj = await axios.post(
        `${constants.gatewayServiceUrl}/evaluation/attendance/submit`,
        payload
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async getAttendance(_, payload) {
    try {
      const resObj = await axios.post(
        `${constants.gatewayServiceUrl}/evaluation/attendance/status`,
        payload
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
};
